import type { PeriodParts } from './types';

export function getToken(): string {
  return localStorage.getItem('access_token') || localStorage.getItem('token') || '';
}

export function authHeaders(): Record<string, string> {
  const token = getToken();
  return {
    'Content-Type': 'application/json',
    Authorization: token ? 'Bearer ' + token : '',
  };
}

export function money(n: number | string | undefined | null): string {
  const v = Number(n) || 0;
  return '$' + v.toLocaleString('en-CA', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatDMY(iso?: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  return dd + '/' + mm + '/' + yyyy;
}

export function derivePeriod(periodEnd?: string | null): PeriodParts {
  if (!periodEnd) return { year: '', month: '' };
  const d = new Date(periodEnd);
  if (isNaN(d.getTime())) return { year: '', month: '' };
  return {
    year: String(d.getFullYear()),
    month: String(d.getMonth() + 1).padStart(2, '0'),
  };
}